import React, { useState } from "react"; 
import { Button, Table, Tag, Space, Card, Input, Select, Radio, message,ConfigProvider ,Empty} from "antd";
import { SearchOutlined, PlusOutlined, FilterOutlined } from "@ant-design/icons";
import EmptyData from "../../Assets/EmptyData.jpg";


const initialData = Array.from({ length: 10 }).map((_, index) => ({
  key: index,
  sno: index + 1,
  hsn: "HSN09876",
  rmName: "Wheat",
  uom: "Tonne",
  fci: "Yes",
  gst: "5",
  remarks: "Nil",
  status: index % 2 === 0 ? "Active" : "Inactive",
}));
 

const RawMaterial = () => {
  const [data, setData] = useState(initialData);
  const [filteredData, setFilteredData] = useState(initialData);
  const [searchText, setSearchText] = useState("");
  const [statusFilter, setStatusFilter] = useState(null);
  const [fciFilter, setFciFilter] = useState(false);

  
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);


  const [formValues, setFormValues] = useState({
    hsn: "",
    rmName: "",
    uom: "",
    fci: "",
    gst: "",
    remarks: "",
    status: "Active",
  });
   const currentMonthName = new Date().toLocaleString("default", { month: "short" }); 
  const cardItems = [
    {
      title: "OverallRawMaterials",
      value: data.length,
    },
    {
      title: "Active",
      value: data.filter((item) => item.status === "Active").length,
    },
    {
      title: "Current Month",
       value: currentMonthName,
    },
  ];

  
  const handleExportCSV = () => {
    const headers = ["S.no", "HSN Code", "RM Name", "UOM", "FCI STK.", "GST %", "Remarks", "Status"];
    const rows = filteredData.map(item => [
      item.sno,
      item.hsn,
      item.rmName,
      item.uom,
      item.fci,
      item.gst,
      item.remarks,
      item.status,
    ]);
    const csvContent = [headers, ...rows].map(row => row.map(v => `"${v}"`).join(",")).join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "raw_materials.csv");
    link.click();
  };

  
  const applyFilters = (search = searchText, status = statusFilter, fciOnly = fciFilter) => {
    let filtered = [...data];

    if (search) {
      const searchLower = search.toLowerCase();
      filtered = filtered.filter(
        (item) =>
          String(item.rmName).toLowerCase().includes(searchLower) ||
          String(item.hsn).toLowerCase().includes(searchLower)
      );
    }

    if (status) {
      filtered = filtered.filter((item) => item.status === status);
    }

    if (fciOnly) {
      filtered = filtered.filter((item) => item.fci === "Yes");
    }

    setFilteredData(filtered);
  };

  
  const handleSearch = (value) => {
    const trimmedValue = value.trim();
    setSearchText(trimmedValue);
    applyFilters(trimmedValue, statusFilter, fciFilter);
  };

  const handleStatusFilter = (status) => {
    setStatusFilter(status);
    applyFilters(searchText, status, fciFilter);
  };

  const handleFCIFilter = () => {
    const newFciFilter = !fciFilter;
    setFciFilter(newFciFilter);
    applyFilters(searchText, statusFilter, newFciFilter);
  };

  const handleAddNew = () => {
    setEditingRecord(null);
    setFormValues({
      hsn: "",
      rmName: "",
      uom: "",
      fci: "",
      gst: "",
      remarks: "",
      status: "Active",
    });
    setIsFormVisible(true);
  };

  const handleEdit = (record) => {
    setEditingRecord(record);
    setFormValues(record);
    setIsFormVisible(true);
  };

  const handleDelete = (key, name) => {
    const updatedData = data.filter((item) => item.key !== key);
    setData(updatedData);
    setFilteredData(updatedData);
    message.success(`"${name}" deleted successfully`);
  };

  const handleSave = () => {
    let updatedData = [];
    if (editingRecord) {
      updatedData = data.map((item) =>
        item.key === editingRecord.key ? { ...editingRecord, ...formValues } : item
      );
      message.success(`"${formValues.rmName}" updated successfully`);
    } else {
      const newRecord = { key: data.length, sno: data.length + 1, ...formValues };
      updatedData = [...data, newRecord];
      message.success(`"${formValues.rmName}" added successfully`);
    }
    setData(updatedData);
    setFilteredData(updatedData);
    setIsFormVisible(false);
  };

  
  const columns = [
    { title: "S.no", dataIndex: "sno", key: "sno" },
    { title: "HSN Code", dataIndex: "hsn", key: "hsn" },
    { title: "RM Name", dataIndex: "rmName", key: "rmName" },
    { title: "UOM", dataIndex: "uom", key: "uom" },
    { title: "FCI STK.", dataIndex: "fci", key: "fci" },
    { title: "GST %", dataIndex: "gst", key: "gst" },
    { title: "Remarks", dataIndex: "remarks", key: "remarks" },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag color={status === "Active" ? "green" : "red"}>{status}</Tag>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space>
          <a style={{ color: "#5590FF" }} onClick={() => handleEdit(record)}>Edit</a>
          <a style={{ color: "red" }} onClick={() => handleDelete(record.key, record.rmName)}>Delete</a>
        </Space>
      ),
    },
  ];


  if (isFormVisible) {
    return (
      <div style={{ padding: 20 }}>
        <h2>{editingRecord ? "Edit Raw Material" : "Add Raw Material"}</h2>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 16 }}>
          <div>
            <label>HSN Code</label>
            <Input
              value={formValues.hsn}
              onChange={(e) => setFormValues({ ...formValues, hsn: e.target.value })}
            />
          </div>
          <div>
            <label>Raw Material Name</label>
            <Input
              value={formValues.rmName}
              onChange={(e) => setFormValues({ ...formValues, rmName: e.target.value })}
            />
          </div>
          <div>
            <label>UOM</label>
            <Select
              value={formValues.uom}
              onChange={(value) => setFormValues({ ...formValues, uom: value })}
              style={{ width: "100%" }}
            >
              <Select.Option value="KG">KG</Select.Option>
              <Select.Option value="LTR">LTR</Select.Option>
              <Select.Option value="TON">TON</Select.Option>
            </Select>
          </div>
          <div>
            <label>GST %</label>
            <Input
              type="number"
              min={0}
              max={100}
              value={formValues.gst}
              onChange={(e) => setFormValues({ ...formValues, gst: e.target.value })}
            />
          </div>
          <div>
            <label>Status</label>
            <Select
              value={formValues.status}
              onChange={(value) => setFormValues({ ...formValues, status: value })}
              style={{ width: "100%" }}
            >
              <Select.Option value="Active">Active</Select.Option>
              <Select.Option value="Inactive">Inactive</Select.Option>
            </Select>
          </div>
          <div>
            <label>FCI Stock</label>
            <Radio.Group
              value={formValues.fci}
              onChange={(e) => setFormValues({ ...formValues, fci: e.target.value })}
            >
              <Radio value="Yes">Yes</Radio>
              <Radio value="No">No</Radio>
            </Radio.Group>
          </div>
          <div style={{ gridColumn: "span 1" }}>
            <label>Remarks</label>
           <Input.TextArea
                rows={3}
                value={formValues.remarks}
                   onChange={(e) => setFormValues({ ...formValues, remarks: e.target.value })}
                       style={{
                resize: "vertical",           
                 overflowY: "auto",            
                minHeight: 50,                
                 maxHeight: 100  ,
                 width:"50%"             
                      }}
                 />

          </div>
        </div>

        <div style={{ textAlign: "center", marginTop: 20 }}>
          <Button type="primary" onClick={handleSave}>Save</Button>
          <Button style={{ marginLeft: 10 }} onClick={() => setIsFormVisible(false)}>Cancel</Button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ padding: 20 }}>
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 16 }}>
        <Space>
          <Button type="primary" style={{ background: "#7E35FE", border: "1px", color:"#fff"}} onClick={handleExportCSV}>Export</Button>
          <Button type="primary" icon={<PlusOutlined />} style={{ background: "#05622C" }} onClick={handleAddNew}>Add New</Button>
          <Button type="default"  icon={<FilterOutlined />}  style={{ border: "1px solid #bfc5d2", color: "#3096E2" }}>Filters</Button>
        </Space>
      </div>
      <div style={{ display: "flex", gap: "16px", marginBottom: "24px" }}>
       {cardItems.map((item, index) => (
        <Card 
          key={index}
          style={{ width: 200, height: 144, textAlign: "center" }}
          bodyStyle={{ display: "flex", flexDirection: "column", justifyContent: "center" }}
        >
          <div style={{ fontWeight: "bold", fontSize: 18 ,display:"flex",justifyContent:"center"}}>{item.title}</div>
          <div style={{ fontSize: 34, color: "#3498ff", fontWeight: 600, marginTop: 12 ,display:"flex",justifyContent:"center"}}>
            {item.value}
          </div>
        </Card>
      ))}
      </div>
      

      
      <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 16 }}>
        <Input
          placeholder="Search by Name or HSN"
          prefix={<SearchOutlined />}
          style={{ width:"100%" }}
          value={searchText}
          onChange={(e) => handleSearch(e.target.value)}
        />
        <Space>
          <Button onClick={() => { setStatusFilter(null); applyFilters(searchText, null, fciFilter); }}>All</Button>
          <Button onClick={() => handleStatusFilter('Active')}>Active</Button>
          <Button onClick={() => handleStatusFilter('Inactive')}>Inactive</Button>
          <Button onClick={handleFCIFilter}>FCI Stock</Button>
        </Space>
      </div>
         <ConfigProvider
          renderEmpty={() => (
            <Empty
              image={EmptyData}
              description="No RawMaterial Data Available"
              imageStyle={{ height: 200 }}
            />
          )}
        >
      <Table columns={columns} dataSource={filteredData} size="small" bordered />
      </ConfigProvider>
    </div>
  );
};

export default RawMaterial;
